import communicareStyles from "./CommunicareWorkaround.module.scss";
import { UserType } from "../../services/medicationmanagement/medsUser/MedsUserApi";
import { ResidentHeader } from "../resident-header/ResidentHeader";
import { ResidentTopBar } from "../resident-header/ResidentTopBar";
import { MountCommunicare } from '../communicare-mount/MountCommunicare';
import { Grid } from "@material-ui/core";
import { ExternalLookupIdentifier } from "@communicare/medications/Shared/SharedModels";
import { Patient } from "../../services/medicationmanagement/patientApi/models/Patient";
import { PatientAllergyInfo } from "../../services/medicationmanagement/patientApi/models/PatientAllergyInfo";
import styles from './ResidentMedications.module.scss';
import {IndividualHealthcareIdentifier} from "../../services/healthcareidentifier/models/IndividualHealthcareIdentifier"
import { useIdentity } from "./../../features/auth/useIdentity";
import { TabsComponent } from "../common";
import { PillIcon, MedicationHistoryIcon } from "@communicare/medications/Components/Icons";
import { Flex, Text } from "@dna/react";
import { RenderIf } from "../common/render-if/RenderIf";
import { PharmacyRequests } from "@communicare/medications/PharmacyRequests/PharmacyRequests";
import { useRouteMatch, useHistory } from 'react-router-dom';

export interface IResidentMedicationsProps {
    resident: Patient;
    encounter: ExternalLookupIdentifier;
    allergyInfo: PatientAllergyInfo;
    ihi: IndividualHealthcareIdentifier;
    //userType: UserType;
    createPharmacyRequest: () => void;
    hasDraftMedications?(flag: boolean): void;
}

export const ResidentMedications = (props: IResidentMedicationsProps) => {
  let { resident, encounter } = props;
  let { push } = useHistory();
  let {  url } = useRouteMatch();
  let { identity } = useIdentity();    

  let handleTabChanged = (selectedIndex: number) => {
     if(selectedIndex === 1)
     {
         push(url)
     }
  }

    const getDraftMedicationFlag = (flag: boolean) => {                   
        if (props.hasDraftMedications !== undefined) {
            props.hasDraftMedications(
                flag ? true : false
            );
        }        
    }
    
  return (
    <Grid container spacing={0} direction={"column"} className={styles.root}>
       <ResidentTopBar resident={props.resident} encounter={props.encounter} ihi={props.ihi} userType={identity?.userType}/>
        <Grid item>
            <ResidentHeader patientInfo={props.resident} allergyInfo={props.allergyInfo} userType={UserType.Doctor} ihi={props.ihi} />
        </Grid>
        <Grid item className={communicareStyles.workaround}>
            <Flex  css={{
                        flex: 1,
                        gap: 0
                    }}
                >
                <TabsComponent
                    headers={[
                        <div>
                            <PillIcon
                              className={styles.tabicon}
                            />
                            <Text level="small" as="strong">MEDICATION CHART</Text>
                        </div>,
                        <div>
                            <MedicationHistoryIcon
                                 className={styles.tabicon}
                            />
                            <Text level="small" as="strong">Change history</Text>
                        </div>
                    ]}
                    content={[
                        <Flex 
                            css={{
                                flex: 1,
                                height: '100%',
                            }}
                        >
                            <MountCommunicare
                                encounter={{ ...encounter }}
                                patient={{
                                    authoringSystem: resident.authoringSystem || "",
                                    authoringSystemForeignKey:
                                    resident.authoringSystemForeignKey || "",
                                    isOnboarding: resident.isOnboarding || false,
                                    isDoctorView : identity?.userType === UserType.Doctor
                                }}
                                navigateToPharmacyRequest={props.createPharmacyRequest}
                                hasDraftMedications = {getDraftMedicationFlag}
                            />
                        </Flex>,
                        <RenderIf if={!!encounter}>
                            <PharmacyRequests patient={{
                                authoringSystem:  resident.authoringSystem || "",
                                authoringSystemForeignKey:  resident.authoringSystemForeignKey || ""
                                }} 
                                service={{
                                authoringSystem: encounter?.authoringSystem,
                                authoringSystemForeignKey: encounter?.authoringSystemForeignKey
                                }}
                                baseUrl={''}
                                routeToMedications={() => { }}
                                headlessMode={true}
                            />
                        </RenderIf>
                    ]}
                    onTabSelectionChanged = {(selectedIndex: number) => handleTabChanged(selectedIndex)}
                />
            </Flex>
        </Grid>
    </Grid>
  );
};
